import React from 'react'
import NavbarComp from './NavbarComp';
import Mycard from './Mycard';
import Row from 'react-bootstrap/Row'
import Figure from 'react-bootstrap/figure'
import Footer from './Footer';

const Who = () => {
    return ( 
        <div >
<NavbarComp />
<div  >
        <Figure>
      <Figure.Image
        width={2000}
        height={100}
        alt="171x180"
        src={require('../video/am10.jpg')}
      />
      
    </Figure>
</div>
   
   <div className='wwho'>
<article>
  <h1>ABOUT US</h1>
 
</article>
<p className='  fw-bold text-white offset-1'>
As-salam Model College old students association (AMCOSA) is a non profitable association which was founded in 2011 to keep in check,the passed out student of As-salam Model College. To improve their lives socially, educationally and morally,also to help improve the standard of the school.
It was founded on the need that that majority of students who have passed out found themselves in a different shape of life,they therefore need a put through,There is also a need for students in the school to be improved academically.
Parts of what we do are distribution of gifts to the best students in each class every year, organizing tutorial for the SSS 3 students for their WAEC,and in view, helping the school with the necessary facilities and equipment needed to make the standard rise above margin.
You are dearly welcome to our page.
</p>
</div>
<Figure>
      <Figure.Image
        width={2000}
        height={100}
        alt="171x180"
        src={require('../video/am3.jpg')}
      />
      
    </Figure>
<div className=' col-12  text-white overflow-hidden mt-5'>
  <h1 className='text-center text-dark '>Advertistments</h1>
 
<Row>
<Mycard img={'spicy'} tittle={'SPICEO'}  description={' All natural ingredientsNo MSG,No sugar,Low sodium  Safe for adults and children,Safe for weight loss plan,Safe for diabetic and hypertensive patients. Enter dm now or contact us on 08166733421 to get yours   '} btn={'watsapp'} link={'http://bit.ly/Spicehub'}  />
 

  <Mycard img={'d9'} tittle={'DREAM9ATION EXCHANGE'} description={'Let us show you the value of your crypto coins.Trade with #Dream9ation #Exchange today! #Dream9ation #payoneer #PayPal #bitcoins #Ethereum #Giftcards'} btn={'website'} link={'https://www.dream9ation.com/'}  />

  <Mycard img={'akm'} tittle={'AKOJEL ICT 08062456354'}  description={'Information and communication technology. our brand is offering website design, programming, training and corporate branding..' } btn={'website'} link={'https://akojelict.netlify.app'} />

  <Mycard img={'pally'} tittle={'TRADE AT EASE WITH MYPALLY'} description={'over the years transacting PayPal funds in Nigeria comes with difficulty. Either fear of losing fund, restriction or scam. With MyPally, you can transact, buy, sell and recieve funds with ease'} btn={'website'} link={'https://mypally.co'}   />
  
  <Mycard img={'muba'} tittle={'ORIFLAME COSMETIC SWEDEN WHATSSAPP:09065921033  FACEBOOK:Abidola Mubarokah Olasunkade IG:lasunkade77'} description={'My name is Mubarokah, now a beauty/skincare consultant with *ORIFLAME cosmetics Sweden* . We deal on beauty products ranging from skin cares, fragrances, colour cosmetics (makeups), hair cares, basically what we use from head to toe, for both men and women. I am now ur go-to girl on anything *Oriflame products*'} btn={'whatsapp'}  link={'https://wa.me/23409065921033?text='} />

</Row>
</div>
<Figure className='mt-3'>
      <Figure.Image
        width={2000}
        height={100}
        alt="171x180"
        src={require('../video/am6.jpg')}
      />
      
    </Figure>
    <div>
      <Footer />
    </div>
        </div>
     );
}
 
export default Who;